<template>
  <div :ref="$refs" class="base-card" v-bind="$props" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseCard",
});
</script>
